import imageCompression from 'browser-image-compression';

export const SUPPORTED_FORMATS = {
  'image/jpeg': { extension: 'jpg', label: 'JPEG' },
  'image/png': { extension: 'png', label: 'PNG' },
  'image/webp': { extension: 'webp', label: 'WebP' },
  'image/gif': { extension: 'gif', label: 'GIF' },
  'image/bmp': { extension: 'bmp', label: 'BMP' },
  'image/tiff': { extension: 'tiff', label: 'TIFF' },
  'image/avif': { extension: 'avif', label: 'AVIF' },
  'image/svg+xml': { extension: 'svg', label: 'SVG' }
};

export const detectImageFormat = (file) => {
  return file.type;
};

export const isValidImageFile = (file) => {
  return Object.keys(SUPPORTED_FORMATS).includes(file.type);
};

export const getCompatibleFormats = (sourceFormat) => {
  // SVG can't be converted to raster formats easily
  if (sourceFormat === 'image/svg+xml') {
    return ['image/svg+xml'];
  }
  
  // All other formats can be converted to most raster formats
  return Object.keys(SUPPORTED_FORMATS).filter(format => format !== 'image/svg+xml');
};

export const convertImage = async (file, targetFormat, onProgress) => {
  return new Promise((resolve, reject) => {
    try {
      // Handle SVG files specially
      if (file.type === 'image/svg+xml') {
        if (targetFormat === 'image/svg+xml') {
          resolve(file);
          return;
        } else {
          reject(new Error('SVG to raster conversion requires vectorization which is not supported in this simple converter'));
          return;
        }
      }

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = async () => {
        try {
          canvas.width = img.width;
          canvas.height = img.height;
          
          // Draw image to canvas
          ctx.drawImage(img, 0, 0);
          
          // Convert canvas to target format
          const quality = targetFormat === 'image/jpeg' ? 0.9 : undefined;
          
          canvas.toBlob(async (blob) => {
            if (!blob) {
              reject(new Error('Failed to convert image'));
              return;
            }

            try {
              // Apply compression if needed
              if (blob.size > 5 * 1024 * 1024) { // 5MB
                const compressedBlob = await imageCompression(new File([blob], 'converted'), {
                  maxSizeMB: 5,
                  maxWidthOrHeight: 4096,
                  useWebWorker: true,
                  onProgress: onProgress
                });
                resolve(compressedBlob);
              } else {
                resolve(blob);
              }
            } catch (compressionError) {
              console.warn('Compression failed, using original:', compressionError);
              resolve(blob);
            }
          }, targetFormat, quality);
        } catch (error) {
          reject(error);
        }
      };

      img.onerror = () => {
        reject(new Error('Failed to load image'));
      };

      img.src = URL.createObjectURL(file);
    } catch (error) {
      reject(error);
    }
  });
};

export const downloadImage = (blob, filename, format) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.${SUPPORTED_FORMATS[format].extension}`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};